import { createContext, useContext } from "react";
import type { OrderRow } from "@features/orders-features/types/types";
import type { OrderDrawerIdentifier, OrderDrawerPreloadedData } from "./types";

export interface OrderDrawerContextValue {
  /** Opens the order drawer for the given order */
  openOrderDrawer: (
    identifier: OrderDrawerIdentifier,
    preloadedData?: OrderDrawerPreloadedData,
  ) => void;
  /** Closes the drawer */
  closeOrderDrawer: () => void;
  /** Opens the Create Return Request dialog for the order; one dialog is hosted for every entry point */
  openReturnRequest: (order: OrderRow) => void;
  /** Whether the drawer is currently open */
  isOpen: boolean;
  /** Whether the drawer feature is available (flag enabled + user has permission) */
  isAvailable: boolean;
  /** Path the open drawer returns to on close, or `undefined` when no drawer is open in the URL */
  basePath?: string;
}

export const OrderDrawerContext = createContext<OrderDrawerContextValue>({
  openOrderDrawer: () => {},
  closeOrderDrawer: () => {},
  openReturnRequest: () => {},
  isOpen: false,
  isAvailable: false,
});

export function useOrderDrawer(): OrderDrawerContextValue {
  return useContext(OrderDrawerContext);
}
